document.addEventListener('DOMContentLoaded', function () {
  const drawers = document.querySelectorAll('.podiatrist-review-drawer');
  const mobileBreakpoint = 749;

  drawers.forEach(function (drawer) {
    const tab = drawer.querySelector('.podiatrist-review-tab');
    const closeBtn = drawer.querySelector('.podiatrist-review-close');

    if (window.innerWidth <= mobileBreakpoint) {
      drawer.classList.remove('is-open');
      drawer.classList.add('is-minimised');
      if (tab) tab.setAttribute('aria-expanded', 'false');
    } else {
      drawer.classList.remove('is-minimised');
      drawer.classList.add('is-open');
      if (tab) tab.setAttribute('aria-expanded', 'true');
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        drawer.classList.remove('is-open');
        drawer.classList.add('is-minimised');
        if (tab) tab.setAttribute('aria-expanded', 'false');
      });
    }

    if (tab) {
      tab.addEventListener('click', function () {
        drawer.classList.remove('is-minimised');
        drawer.classList.add('is-open');
        tab.setAttribute('aria-expanded', 'true');
      });
    }
  });
});